/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import ReactLoading from 'react-loading';
import Cookies from 'js-cookie';

import moment from 'moment';

import api from 'api';
import { ImDownload3 } from 'react-icons/im';
import { Header, SideMenu, Button, Dialog, Input } from 'components';
import { Container, ContentArea, Title, Div, ModalButton } from './styles';
import { toast } from 'react-toastify';
import { white } from 'styles/colorProvider';
import ExportToExcel from 'components/ExportToExcel/index';
import { Alert } from '@material-ui/lab';

function DownloadReports() {
  const [exportData, setExportData] = useState();
  const [openExport, setOpenExport] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [loading, setLoading] = useState(false);
  const [exportErrorMessage, setExportErrorMessage] = useState('');

  const filename = `Planilha_Importacao_Padrao - SPLIT RISK SEGURADORA (${moment().format('DD-MM-YYYY')}).csv`;

  const renderExportDialog = () => (
    <Dialog
      open={openExport}
      onClose={() => {
        !loading && setOpenExport(false);
        setExportErrorMessage('');
        setExportData();
      }}
      width="50%"
      height={'100px'}
      title="Exportar base"
    >
      {!exportData && (
        <>
          <div
            style={{
              width: '100%',
            }}
          >
            <>
              <Input
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                widht="30%"
                label={`Data inicial`}
                mask="99/99/9999"
                height="30px"
              />
              <Input
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                widht="30%"
                label={`Data final`}
                mask="99/99/9999"
                height="30px"
              />
            </>
          </div>
          {exportErrorMessage && (
            <Alert severity="error" style={{ width: '90%', height: '30px', marginTop: '15px' }}>
              {exportErrorMessage}
            </Alert>
          )}
          <ModalButton>
            <Button height="35px" style={{ margin: '2rem 0 0 0' }} onClick={handleExport} disabled={loading}>
              {loading ? <ReactLoading color={white} height={25} width={25} type="spin" /> : 'Exportar'}
            </Button>
          </ModalButton>
        </>
      )}

      {exportData?.url ? (
        <>
          <p>Seu arquivo está pronto!</p>
          <p>
            {' '}
            <a href={exportData?.url} target="_blank" rel="noreferrer">
              Clique aqui para baixar
            </a>
          </p>
        </>
      ) : (
        <p>{exportData?.message}</p>
      )}
    </Dialog>
  );

  const handleExport = async () => {
    setLoading(true);

    setExportErrorMessage('');

    const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;

    const isStartDateValid = !startDate || datePattern.test(startDate);
    const isEndDateValid = !endDate || datePattern.test(endDate);

    if (!startDate || !endDate) {
      setExportErrorMessage('Informe as datas de início e de fim.');
      setLoading(false);
      return;
    }

    if (!isStartDateValid || !isEndDateValid) {
      setExportErrorMessage('Formato de data inválido.');
      setLoading(false);
      return;
    }

    const momentStartDate = moment(startDate, 'DD/MM/YYYY');
    const momentEndDate = moment(endDate, 'DD/MM/YYYY');

    if (momentEndDate.isBefore(momentStartDate)) {
      setExportErrorMessage('A Data final deve ser maior que a inicial.');
      setLoading(false);
      return;
    }

    try {
      const resp = await api({
        method: 'GET',
        url: `/report/care-export`,
        params: {
          startDate: startDate,
          endDate: endDate,
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
          feature: 'care-export',
        },
        json: true,
      });
      setExportData(resp?.data);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Não foi possível exportar os relatórios.', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      setOpenExport(false);
    } finally {
      setLoading(false);
      setStartDate();
      setEndDate();
      setExportErrorMessage('');
    }
  };

  return (
    <>
      {renderExportDialog()}
      <Header />
      <Container>
        <SideMenu />
        <ContentArea>
          <Div>
            <Title>Baixar Relatórios</Title>
          </Div>
          <Button width="280px" onClick={() => setOpenExport(true)} disabled={loading}>
            {loading ? (
              <ReactLoading color="#fff" height={25} width={25} type="spin" />
            ) : (
              <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <ImDownload3 style={{ marginRight: 5 }} /> Baixar base atualizada
              </span>
            )}
          </Button>
        </ContentArea>
      </Container>
    </>
  );
}

export default DownloadReports;
